export const BASE_URL = "http://localhost:3001/"
export const ASSETS_URL = process.env.REACT_APP_ASSETS_URL
export const ADMIN_API_URL = process.env.REACT_APP_ADMIN_SERVICE_API_BASE_URL
export const CREDIT_API_URL = process.env.REACT_APP_CREDIT_SERVICE_API_BASE_URL

// Lender IDs
export const CASHE_LENDER_ID = "CASHE_001"

// User Type Options
export const USER_TYPE_OPTIONS = [
    { value: 0, label: "Employee" },
    { value: 1, label: "Anchor Company" },
    { value: 2, label: "Lead Channel Partner" }
];